export const routesUser = [
  {
    path: "/profil",
    name: "profil",
    component: () => import("@/views/user/profil/index.vue"),
    meta: { public: false, title: "user.Profil" },
  },
]
